import { IReward } from './IReward';
import { Reward } from './Reward';
import AchTransactionTypes from '../AchTransactionTypes';

export class AchAggregateFeeReductionReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.AchAggregateFeeReductionReward';

	public static readonly NAME: string = 'ACH Aggregate Fee Reduction';

	achTransactionType: string = AchTransactionTypes.ACH_DEBIT.value;

	achAggregateFeeReductionAmount: number = 0;

	minimumAggregateAmount: number = 0;

	constructor(reward?: IReward) {
	  super(AchAggregateFeeReductionReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.achTransactionType = (reward as any).achTransactionType;
	    this.achAggregateFeeReductionAmount = (reward as any).achAggregateFeeReductionAmount;
	    this.minimumAggregateAmount = (reward as any).minimumAggregateAmount;
	  }
	}

	getDescription(): string {
	  return `$${this.achAggregateFeeReductionAmount} fee reduction on ${this.achTransactionType} aggregate $${this.minimumAggregateAmount} or more`;
	}

	clone(): IReward {
	  const clone = new AchAggregateFeeReductionReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default AchAggregateFeeReductionReward;
